import React from "react";
import { SMC_FORM_SCHEMA, SMC_TYPE_ORDER } from "./smcSchema";
import "./createSmc.css";

const TypePicker = ({ onSelect }) => (
  <div className="smc-picker">
    <h2 className="smc-picker-title">What kind of ticket?</h2>
    <p className="smc-picker-subtitle">Pick the type that matches the request you need to file.</p>
    <div className="smc-picker-grid">
      {SMC_TYPE_ORDER.map((typeKey) => {
        const t = SMC_FORM_SCHEMA[typeKey];
        return (
          <button
            key={typeKey}
            type="button"
            className={`smc-type-card smc-accent-${t.accent}`}
            onClick={() => onSelect(typeKey)}
          >
            <div className="smc-type-card-bar" />
            <div className="smc-type-card-body">
              <div className="smc-type-card-icon-wrap">
                <img src={t.icon} alt="" />
              </div>
              <h3 className="smc-type-card-title">{t.label}</h3>
              <p className="smc-type-card-desc">{t.description}</p>
              <span className="smc-type-card-cta">
                Continue
                <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
                  <path fill="none" stroke="currentColor" strokeWidth="1.75"
                    strokeLinecap="round" strokeLinejoin="round"
                    d="M2 8h11M9 4l4 4-4 4"/>
                </svg>
              </span>
            </div>
          </button>
        );
      })}
    </div>
  </div>
);

export default TypePicker;
